import React, { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { TabPanel, Tabs } from 'react-tabs'
import registerGraphic from '../../assets/images/login/register1-graphic (1).png'
import axios, { PublicKey } from '../../API/axios'
import toast from 'react-hot-toast'


const ConfirmPassword = () => {
  const [showPass, setShowPass] = useState(false);
  const [showPass1, setShowPass1] = useState(false);

  const [showPass3, setShowPass3] = useState(false);
  const [showPass4, setShowPass4] = useState(false);

  const [isShowMobile, setShowMobile] = useState(false);
  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const UserUID = queryParams.get('UserUID');
  const Token = queryParams.get('Token');

  // Use UserUID and Token in your component logic
  console.log(UserUID, Token);


  const [newpassword, setnewPassword] = useState('')
  const [confirmpassword, setconfirmPassword] = useState('')
  const [displays, setDisplays] = useState(false)
  const setPassword = async (e) => {
    e.preventDefault()
    const responseData1 = {
      "newPassword": newpassword,
      "confirmPassword": confirmpassword
    }
    try {

      setDisplays(true)
      if (newpassword && confirmpassword !== '') {
        const res = await axios.post(`/Auth/SetNewPassword?UserUID=${UserUID}&Token=${Token}`, responseData1,
          {
            headers: {
              PublicKey,
            },
          }
        );
        console.log('ghgh', res);
        toast.success(res.data.message)
      } else {
        toast.error("please enter required fields!")
        // { position: "top-center" }
      }

    } catch (error) {
      if (error.response && error.response.status === 404) {
        toast.warning(error.response.data.message)
      } else {
        toast.error(error.response.data.message)
      }
    };
  }
  return (
    <>
      <section className="account-section p-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6 registerGraphics">
              <img src={registerGraphic} />
            </div>
            <div className="col-md-6">
              <Tabs className="wd-form-login tf-tab">
                {/* <p>User Email Address</p> */}
                <h4 className="mt-3">Set New Password</h4>
                <div className="content-tab">
                  <TabPanel className="inner animation-tab">
                    <form action="/">
                      <div className="ip">
                        <label>New Password</label>
                        <div className="inputs-group auth-pass-inputgroup">
                          <input
                            type={showPass ? "text" : "password"}
                            className="input-form password-input"
                            placeholder="New Password"
                            id="password-input"

                            onChange={(e) => setnewPassword(e.target.value)}
                            value={newpassword}
                            invalid={displays && newpassword === ''}
                          />
                          <Link
                            className={`password-addon ${showPass ? "icon-eye" : "icon-eye-off"
                              }`}
                            id="password-addon"
                            onClick={() => setShowPass(!showPass)}
                          />
                          {displays && !newpassword ? <span className='error_msg_lbl text-red'>Enter New Password </span> : null}
                        </div>
                      </div>
                      <div className="ip">
                        <label>Confirm Password</label>
                        <div className="inputs-group auth-pass-inputgroup">
                          <input
                            type={showPass1 ? "text" : "password"}
                            className="input-form password-input"
                            placeholder="Confirm Password"
                            id="password-input"

                            onChange={(e) => setconfirmPassword(e.target.value)}
                            value={confirmpassword}
                            invalid={displays && confirmpassword === ''}
                          />
                          <Link
                            className={`password-addon ${showPass1 ? "icon-eye" : "icon-eye-off"
                              }`}
                            id="password-addon"
                            onClick={() => setShowPass1(!showPass1)}
                          />
                          {displays && !confirmpassword ? <span className='error_msg_lbl text-red'>Enter Confirm Password </span> : null}
                        </div>
                      </div>
                      <button onClick={(e) => { setPassword(e) }}>Reset</button>
                    </form>
                  </TabPanel>
                </div>
              </Tabs>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ConfirmPassword